import * as yup from 'yup';

const requiredErrorMessage = 'This field is required';

export const assignModalSchema = yup.object().shape({
  type: yup.string().required(requiredErrorMessage),

  team_id: yup
    .string()
    .when('type', ([type], schema) =>
      type === 'team'
        ? schema.required(requiredErrorMessage)
        : schema.optional(),
    ),
  user_id: yup
    .string()
    .when('type', ([type], schema) =>
      type === 'user'
        ? schema.required(requiredErrorMessage)
        : schema.optional(),
    ),
  assign_to_self: yup.boolean().optional(),
  assign_to_assigned_cm: yup.boolean().optional(),
});
